import React, {useContext,useState,useEffect,useRef, useMemo, useCallback } from "react";
import { AppContext } from "../../context/AppContext";
import "./containerRestau.css"
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { formatRestaurantNote, GoldStar, isNewRestaurant, useRestaurantFavorite, useRestaurantLink } from "./hookContainerRestau";
import { HookHeartIcon } from "../../hookIcons/hookIconsHeart";

interface containerRestauProps {
    id:number,
    idResto:number,
    img : string,
    note: number,
    name: string,
    id_url:string,
    imgSup?:string[],
    type:string,
    visibleCity?:string,
    city:string,
    nbr_review:number,
    price_range:[number,number],
    isLarge?:boolean,
    date_published?:Date,
    imgLocked?:boolean,
    def_cuisine:string,
    neighborhood:string,
}
const preloadAndDecode = (src: string) =>
    new Promise<void>((resolve) => {
        const im: HTMLImageElement = new Image();
        im.src = src;
        const done = () => resolve();
        if ("decode" in im) {
        im.decode()
            .then(done)
            .catch(() => {
            im.onload = done;
            im.onerror = done;
            });
        } else {
        (im as HTMLImageElement).onload = done;
        (im as HTMLImageElement).onerror = done;
        }
});
const ContainerRestauInner:React.FC<containerRestauProps> = ({id,isLarge=false,imgLocked=false,date_published,id_url,idResto,img,city,visibleCity,note,name,imgSup,type,nbr_review,price_range,def_cuisine,neighborhood}) => {
    const {isLogin,setConnectionScreen,restoFav,setRestoFav} = useContext(AppContext)
    const transitionFallbackRef = useRef<number | null>(null);

    const activeImageIndex = useRef<number[]>([0,1]);
    const [currentImgPhone, setCurrentImgPhone] = useState(0);

    const canHover = useMemo(() => 
        typeof window !== "undefined" && window.matchMedia("(hover: hover) and (pointer: fine)").matches,
    []);

    const [isSwipePhone,setIsSwipePhone] = useState(false)

    const [isSlide, setIsSlide] = useState(false)
    const [isHovered, setIsHovered] = useState(false)
    const [isFirst, setIsFirst] = useState(true)
    const [zindexBase,setZindexBase] = useState(-1)
    const containerRef = useRef<HTMLDivElement>(null);
    const timeouts = useRef<NodeJS.Timeout[]>([]);
    const images = useMemo(() => imgSup ? [img,...imgSup] : [img], [img, imgSup]);
    let isNew = isNewRestaurant(date_published);
    const linkResto = useRestaurantLink(city,name,id_url);

    useEffect(() => {
        if (window.innerWidth <= 768) return;
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = [];
        timeouts.current.push(
        setTimeout(() => {
        if(isHovered && images.length > 1) {
            const slideFirst = document.getElementById('slideFirstRestau'+id)
            const slideSecond = document.getElementById('slideSecondRestau'+id)
            const nextIndex = isFirst ? activeImageIndex.current[1] : activeImageIndex.current[0];

            
            if(isFirst && slideFirst && slideSecond) {
                setCurrentImgPhone(nextIndex);
                slideFirst.classList.add('sliding')
                slideSecond.style.zIndex = '0'
                slideSecond.classList.remove('right')
                timeouts.current.push(
                    setTimeout(() => {
                            slideFirst.style.zIndex = '-10'
                            slideFirst.classList.remove('sliding')
                            slideFirst.classList.add('right')
                    },750 ))
                
            }
            else if(!isFirst && slideFirst && slideSecond) {
                setCurrentImgPhone(nextIndex);
                slideSecond.classList.add('sliding')
                slideFirst.style.zIndex = '0'
                slideFirst.classList.remove('right')
                timeouts.current.push(
                    setTimeout(() => {
                        slideSecond.style.zIndex = '-10'
                        slideSecond.classList.remove('sliding')
                        slideSecond.classList.add('right')
                    },750 )    
                )  
            }
            timeouts.current.push(
            setTimeout(() => {
                if(isHovered) {
                    if(isFirst) {
                        const nextIndex = activeImageIndex.current[1];
                        activeImageIndex.current = [nextIndex+1 >= images.length ? 0 : nextIndex+1,nextIndex]
                    }
                    else {
                        const nextIndex = activeImageIndex.current[0];
                        activeImageIndex.current = [nextIndex,nextIndex+1 >= images.length ? 0 : nextIndex+1]
                    }
                    setIsFirst(!isFirst)
                }
            },1000)  
            )  
        }
        else if (isHovered) {
            const container = document.getElementById('containerRestau'+id)
            if(container) {
                container.classList.add('noDefilment');
                setTimeout(() => container.classList.remove('noDefilment'), 200);
            }
        }
        else {
            handleMouseLeave()
        }
        return () => {
            timeouts.current.forEach((timeout) => clearTimeout(timeout));
            timeouts.current = [];
          };
        },500))

    },[isHovered,isFirst])


    const handleMouseEnter = () => {
        if (window.innerWidth <= 765) return;
        setIsFirst(true)
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = []     
        const slideFirst = document.getElementById('slideFirstRestau'+id)
        const slideSecond = document.getElementById('slideSecondRestau'+id)
        if(slideFirst && slideSecond) {
            slideFirst.style.transition = 'transform 0.7s ease '
            slideSecond.style.transition = 'transform 0.7s ease'
            setZindexBase(-1)
            setIsHovered(true)
        }
    }
    const handleMouseLeave = () => {
        if (window.innerWidth <= 765) return;
        timeouts.current.forEach((timeout) => clearTimeout(timeout));
        timeouts.current = []
        setIsHovered(false)
        activeImageIndex.current = [0,1]
        setCurrentImgPhone(0)
        setZindexBase(1)
        const slideFirst = document.getElementById('slideFirstRestau'+id)
        const slideSecond = document.getElementById('slideSecondRestau'+id)
        if(slideFirst && slideSecond) {
            slideFirst.style.transition = 'transform 0.001s linear';
            slideSecond.style.transition = 'transform 0.001s linear';
            slideFirst.style.zIndex='0'
            slideSecond.style.zIndex='0'
            slideFirst.classList.remove('sliding','right')
            slideSecond.classList.remove('sliding')
            slideSecond.classList.add('right') 
        } 
    }
    const { fav, handleFav } = useRestaurantFavorite({idrestaurant:idResto,isLogin,restoFav,setRestoFav,setConnectionScreen,});
    
    const touchStartX= useRef(0);
    const touchStartY= useRef(0);
    const touchStartTime = useRef(0);
    const lastTouchX = useRef(0);
    const currentImgRef = useRef(0);
    useEffect(() => {
        currentImgRef.current = currentImgPhone;
    }, [currentImgPhone]);

    const isDragging = useRef(false);
    const swipeDirection = useRef<1 | -1 | 0>(0); 
    const cardWidthRef = useRef(0);
    const didPreloadFirstSwipeRef = useRef(false);
    const slideCenterRef = useRef<HTMLDivElement>(null);
    const slideOtherRef = useRef<HTMLDivElement>(null);
    const imgCenterRef = useRef<HTMLImageElement | null>(null);
    const imgOtherRef = useRef<HTMLImageElement | null>(null);

    const centerIdxRef = useRef(0);
    const otherIdxRef = useRef(images.length > 1 ? 1 : 0);
    const isTransitioning = useRef(false);
    const finishSwipeTransition = useCallback(() => {
        if (transitionFallbackRef.current !== null) {
            window.clearTimeout(
                transitionFallbackRef.current
            );
            transitionFallbackRef.current = null;
        }
        isTransitioning.current = false;
        isDragging.current = false;
        swipeDirection.current = 0;
        setIsSwipePhone(false);
    }, []);
    useEffect(() => {
        if (imgLocked) return;
        centerIdxRef.current = 0;
        otherIdxRef.current = images.length > 1 ? 1 : 0;
        if (imgCenterRef.current) imgCenterRef.current.src = images[0];
        if (imgOtherRef.current) imgOtherRef.current.src = images[otherIdxRef.current];
        setCurrentImgPhone(0);
    }, [imgLocked,images]);
    const updateUpInfo = useCallback((prevId:number) => {return prevId+1 >= images.length ? 0 : prevId+1},[images.length]);
    const updateDownInfo = useCallback((prevId:number) => {return prevId-1 < 0 ? images.length-1 : prevId-1},[images.length]);

    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        if (canHover || images.length <= 1 || isSwipePhone ||  isTransitioning.current) return;
        if (!didPreloadFirstSwipeRef.current) {
            didPreloadFirstSwipeRef.current = true;

            const nextIdx = images.length > 1 ? 1 : 0;
            const nextSrc = images[nextIdx];
            preloadAndDecode(nextSrc)
        }
        e.stopPropagation();

        const touch = e.touches[0];
        touchStartX.current = touch.clientX;
        touchStartY.current = touch.clientY;
        lastTouchX.current = touch.clientX;
        touchStartTime.current = performance.now();

        isDragging.current = true;
        swipeDirection.current = 0;
        setIsSlide(true);

        if (containerRef.current) cardWidthRef.current = containerRef.current.offsetWidth || window.innerWidth;

        const slideCenter = slideCenterRef.current;
        const slideOther = slideOtherRef.current;
        if (slideCenter && slideOther) {
            slideCenter.style.transition = 'none';
            slideOther.style.transition = 'none';
            slideCenter.style.transform = 'translateX(0px)';
            slideOther.style.transform = 'translateX(100%)';
            slideCenter.style.zIndex = '2';
            slideOther.style.zIndex = '1';
            slideCenter.style.opacity = "1";
            slideOther.style.opacity = '1';

        }
    };
    
    useEffect(() => {
        const container = containerRef.current;
        if (!container || canHover || images.length <= 1) return;

        const handleMove = (e: TouchEvent) => {
            if (!isDragging.current || isTransitioning.current) return;

            const touch = e.touches[0];
            const touchX = touch.clientX;
            const touchY = touch.clientY;

            const deltaX = touchX - touchStartX.current;
            const deltaY = touchY - touchStartY.current;

            if (swipeDirection.current === 0) {
                if (Math.abs(deltaX) < 5 && Math.abs(deltaY) < 5) return;
                if (Math.abs(deltaY) > Math.abs(deltaX) * 1.2) {
                    isDragging.current = false;
                    return;
                }

                swipeDirection.current = deltaX < 0 ? -1 : 1;
                const baseIndex = centerIdxRef.current;
                const nextIndex =
                    swipeDirection.current === -1
                        ? updateUpInfo(baseIndex)
                        : updateDownInfo(baseIndex);
                if (imgOtherRef.current) {
                imgOtherRef.current.src = images[nextIndex];
                }
                otherIdxRef.current = nextIndex;
            }else {
                const newDirection = deltaX < 0 ? -1 : 1;
                if (newDirection !== swipeDirection.current && Math.abs(deltaX) > 10) {
                    swipeDirection.current = newDirection;
                    const baseIndex = centerIdxRef.current;
                    const nextIndex =
                        swipeDirection.current === -1
                            ? updateUpInfo(baseIndex)
                            : updateDownInfo(baseIndex);

                    otherIdxRef.current = nextIndex;
                    if (imgOtherRef.current) imgOtherRef.current.src = images[nextIndex];
                }
            }
            if (e.cancelable) e.preventDefault();
            lastTouchX.current = touchX;

            const slideCenter = slideCenterRef.current;
            const slideOther = slideOtherRef.current;
            if (!slideCenter || !slideOther) return;

            const width = cardWidthRef.current|| 1;
            const direction = swipeDirection.current;

            slideCenter.style.transition = 'none';
            slideOther.style.transition = 'none';

            if (direction === -1) {
                const offsetCenter = deltaX;
                const offsetOther = width + deltaX;
                slideCenter.style.transform = `translateX(${offsetCenter}px)`;
                slideOther.style.transform = `translateX(${offsetOther}px)`;
            } else if (direction === 1) {
                const offsetCenter = deltaX;
                const offsetOther = -width + deltaX;
                slideCenter.style.transform = `translateX(${offsetCenter}px)`;
                slideOther.style.transform = `translateX(${offsetOther}px)`;
            }
        };
        container.addEventListener('touchmove', handleMove, { passive: false });

        return () => {
            container.removeEventListener('touchmove', handleMove);
        };
    }, [canHover, images.length, id, updateUpInfo, updateDownInfo]); 

    const handleTouchEnd =  (e: React.TouchEvent<HTMLDivElement>) => {
        if (canHover || images.length <= 1) return;
        e.stopPropagation();

        if (!isDragging.current) return;
        isDragging.current = false;

        const container = containerRef.current;
        const slideCenter = slideCenterRef.current;
        const slideOther = slideOtherRef.current;
        if (!container || !slideCenter || !slideOther) return;

        const width = cardWidthRef.current || container.offsetWidth || 1;
        const deltaX = lastTouchX.current - touchStartX.current;
        const duration = performance.now() - touchStartTime.current;
        const absDeltaX = Math.abs(deltaX);
        const direction = swipeDirection.current; 

        if (direction === 0) {
            slideCenter.style.transition = 'transform 0.25s ease';
            slideOther.style.transition = 'transform 0.25s ease';
            slideCenter.style.transform = 'translateX(0px)';
            slideOther.style.transform = 'translateX(100%)';
            swipeDirection.current = 0;
            return;
        }
        const HALF_THRESHOLD = width * 0.5;
        const FAST_SWIPE_DISTANCE = width * 0.15;
        const FAST_SWIPE_TIME = 220;

        const isOverHalf = absDeltaX > HALF_THRESHOLD;
        const isFastSwipe = absDeltaX > FAST_SWIPE_DISTANCE && duration < FAST_SWIPE_TIME;
        const shouldChange = isOverHalf || isFastSwipe;

        slideCenter.style.transition = 'transform 0.25s ease';
        slideOther.style.transition = 'transform 0.25s ease';

        if (shouldChange) {
            isTransitioning.current = true;
            setIsSwipePhone(true);
            setCurrentImgPhone(otherIdxRef.current);
            const w = width;
            const dir = direction;

            slideCenter.style.transition = "transform 0.25s ease";
            slideOther.style.transition = "transform 0.25s ease";

            slideCenter.style.transform = `translateX(${dir === -1 ? -w : w}px)`;
            slideOther.style.transform = "translateX(0px)";
            let transitionFinished = false;
            const onEnd = () => {
                if (transitionFinished) return;
                transitionFinished = true;

                if (transitionFallbackRef.current !== null) {
                    window.clearTimeout(transitionFallbackRef.current);
                    transitionFallbackRef.current = null;
                }
                centerIdxRef.current = otherIdxRef.current;
                const centerImg = imgCenterRef.current;
                const otherImg = imgOtherRef.current;
                const resetSlides = () => {
                    requestAnimationFrame(() => {
                        slideCenter.style.transition = "none";
                        slideOther.style.transition = "none";
                        slideCenter.style.transform = "translateX(0px)";
                        slideOther.style.transform = "translateX(100%)";
                        swipeDirection.current = 0;
                        const nextOther = updateUpInfo(centerIdxRef.current);
                        otherIdxRef.current = nextOther;
                        if (imgOtherRef.current) {
                            imgOtherRef.current.src = images[nextOther];
                        }
                        preloadAndDecode(images[nextOther]);
                        finishSwipeTransition();
                    });
                };
                if (centerImg && otherImg) {
                    centerImg.src = otherImg.currentSrc || otherImg.src;

                    centerImg
                        .decode()
                        .catch(() => {})
                        .finally(resetSlides);
                } else {
                    resetSlides();
                }
            };
            slideCenter.addEventListener("transitionend", onEnd , { once: true });
            transitionFallbackRef.current =
            window.setTimeout(() => {
                onEnd();
            }, 400);

        } else {
            slideCenter.style.transform = 'translateX(0)';
            slideOther.style.transform = direction === -1 ? 'translateX(100%)' : 'translateX(-100%)';
            setTimeout(() => {
                slideCenter.style.transition = 'none';
                slideOther.style.transition = 'none';
                slideCenter.style.transform = 'translateX(0px)';
                slideOther.style.transform = 'translateX(100%)';
                swipeDirection.current = 0;
            }, 260);
        }
    };
    const handleTouchCancel = () => {
        isDragging.current = false;
        swipeDirection.current = 0;

        if (isTransitioning.current) {
            return;
        }

        const slideCenter = slideCenterRef.current;
        const slideOther = slideOtherRef.current;

        if (!slideCenter || !slideOther) return;

        slideCenter.style.transition = "transform 0.2s ease";
        slideOther.style.transition = "transform 0.2s ease";

        slideCenter.style.transform = "translateX(0px)";
        slideOther.style.transform = "translateX(100%)";
    };
    const handleCurrentImg = (index:number) => {
        if (index === centerIdxRef.current || isSwipePhone || isTransitioning.current || images.length <= 1) return;
        isTransitioning.current = true;
        const nextOther = updateUpInfo(index);
        centerIdxRef.current = index;
        otherIdxRef.current = nextOther;
        if (imgCenterRef.current) imgCenterRef.current.src = images[index];
        if (imgOtherRef.current) imgOtherRef.current.src = images[nextOther];
        setCurrentImgPhone(index);
        setTimeout(() => {
            isTransitioning.current = false;
        }, 50);
    }

    const noteUse = formatRestaurantNote(note)
    const altImg = `${name} - ${visibleCity || city}`
    return (
        <div className={`containerRestauUp ${id%3 !== 0 && 'notFirst'} ${isLarge && 'large'} ${canHover ? 'canHover' : 'cantHover'}`}>
            <Link to={linkResto} state={{ skipSplash: true }} target="_blank" rel="noopener" className='containerRestau' id={`containerRestau`+id}  onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} >
                
                {isNew && <span className="isNew smallTextBold">Nouveau</span>}
                <div className="imageZoneRestau">
                    {canHover ? <>
                    <div className="slideBase forComputer" id={'slideBaseRestau'+id} style={{zIndex:zindexBase}} >
                        {images[activeImageIndex.current[0]] && !imgLocked && <img src={images[activeImageIndex.current[0]]} loading={id === 0 ? "eager" : "lazy"} {...(id === 0 && { fetchpriority: 'high' })} alt={altImg} /> }
                    </div>
                    <div className="slideFirst forComputer" id={'slideFirstRestau'+id} >
                        {images[activeImageIndex.current[0]] && isHovered &&  <img  src={images[activeImageIndex.current[0]]} loading="eager"  decoding="async" alt={altImg} />}
                    </div>
                    <div className="slideSecond right forComputer"  id={'slideSecondRestau'+id} >
                        { isHovered && <img  src={images[activeImageIndex.current[1]]} loading="lazy"  decoding="async" alt={altImg} /> }
                    </div></> :

                    <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onTouchCancel={handleTouchCancel}  ref={containerRef}> 
                        <div className="slideFirst forPhone " id={`slideRestauPhone0`+id} ref={slideCenterRef}>
                            { !imgLocked && <img ref={imgCenterRef}  loading={id === 0 ? "eager" : "lazy"}  alt={altImg}  {...(id === 0 && { fetchpriority: 'high' })}/> }
                        </div>

                        <div className="slideSecond forPhone"  id={`slideRestauPhone1`+id} ref={slideOtherRef}>
                        {isSlide  && <img ref={imgOtherRef} loading="eager"  alt={altImg} />
                        }</div>
                    </div> }
                    <div className="shadowImg"></div>
                </div>
                <div className="separation"></div>
                <div className={`footerContainerRestau primaryBack smallText`} >
                    {images.length > 1 && <div className="slideIndicator" >
                        {
                            images.map((elem,id) => {
                                return <div key={'elemSlideIndicator'+id} className={`${currentImgPhone === id && 'select'} ${(currentImgPhone === id+1 || currentImgPhone === id-1) && 'nextSelect'}`} onClick={(e) => {e.stopPropagation();e.preventDefault();if(currentImgPhone !== id){handleCurrentImg(id)}}}>

                                </div>
                            })
                        }
                    </div>}
                    <div className="containerFirstAndScnd">
                        <div className="leftPart">
                            <div className="firstLine">
                                <h3 className='title midTextBold' translate="no">{name}</h3>
                            </div>
                            <div className="scndLine">
                                <h4 className="type" >{type}</h4>
                            </div>
                        </div>
                        <div className="rightPart">
                            <div className={`rate midText ${noteUse ? '' : 'rateHidden'}`}>
                                <span> {formatRestaurantNote(note || 1)}</span>
                                <GoldStar id={idResto} className="star" size={23} />
                                <span className="nbrReview ">{`(${nbr_review})`}</span>
                            </div>
                            <div className="price">
                                <p>{price_range[0] ?? 20} - {price_range[1] ?? 30}€</p> 
                            </div>
                        </div>
                    </div>
                    
                    <h4 className="thirdLine">
                        <FaMapMarkerAlt  size={14} className="icon"/> 
                        {visibleCity ? visibleCity : city} {neighborhood ? ` / ${neighborhood}` : ''}
                    </h4>
                    {def_cuisine && <div className="fourthLine smallText">
                        <span className="cuisineText">“{def_cuisine}”</span>
                    </div>}
                </div> 
                {   
                    isLogin !== 2 && <div className="heart flexAllCenter pointer" onClick={(e) => {e.preventDefault();e.stopPropagation();handleFav()}}>
                        <HookHeartIcon className=" lowOpacityHover pointer"  color={!fav ? "#fdfcfc" : "#f00"}  size={33}/>
                    </div>
                }
            </Link>    
        </div>
    )
}
const ContainerRestau = React.memo(ContainerRestauInner);

export { ContainerRestau }
